// extracted by mini-css-extract-plugin
export default {"container":"ActivityView_container__m47OD","details":"ActivityView_details__au2Zr","paragraph":"ActivityView_paragraph__b2PLJ"};